import React from "react";
import { UsageStatistics } from "./usage-statistics/usage-statistics";

const StatisticsPage: React.FC = () => {
	return <UsageStatistics />;
};

export default StatisticsPage;
